import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Tooltip,
  Typography,
  Card, AppBar, Toolbar, InputLabel, Select, MenuItem, FormControl,
  Grid,
  Table,
  TableHead,
  CircularProgress,
  TableContainer,
  Modal,
  TextField,
  Paper,
  InputAdornment,
  Box,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import { useParams } from "react-router-dom";
import base64 from "base64-js";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


function AssignmentCreate() {
  const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(1);

  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [canAdd, setCanAdd] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [assignments, setAssignments] = useState([]);
  const [assignmentToDelete, setAssignmentToDelete] = useState([]);
  const [filteredAssignments, setFilteredAssignments] = useState([]);
  const navigate = useNavigate();

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId }),
      });
      const result = await response.json();
      const data = result[0];
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };

  const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};

useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  if (isMasterUser) {
    fetchBranches();
  } else {
    const branchId = sessionStorage.getItem("branchId");
    setSelectedBranchId(branchId);
  }
}, []);

const fetchAssignments = async () => {
  try {
    setLoading(true);
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/AssignmentCreate/GetAssignmentAll`;
    const token = sessionStorage.getItem("token");
    const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

    const response = await fetch(`${apiUrl}?Branch_Id=${branchId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ Branch_Id: branchId }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch assignments");
    }

    const data = await response.json();
    
    // Check if the response indicates no records found
    if (data.msg === "Record Not Found" || data.status === null) {
      setAssignments([]);
      setFilteredAssignments([]);
      return;
    }
    
    if (Array.isArray(data)) {
      const reversedData = [...data].reverse();
      setAssignments(reversedData);
      setFilteredAssignments(reversedData);
    } else if (data.assignments && Array.isArray(data.assignments)) {
      const reversedData = [...data.assignments].reverse();
      setAssignments(reversedData);
      setFilteredAssignments(reversedData);
    } else {
      console.error("Unexpected data structure:", data);
      setAssignments([]);
      setFilteredAssignments([]);
    }
  } catch (error) {
    console.error("Error fetching assignments:", error);
    setAssignments([]);
    setFilteredAssignments([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    const url = process.env.REACT_APP_BASE_URL;
    const apiUrl = `${url}/AssignmentCreate/GetAssignmentAll`;
    const token = sessionStorage.getItem("token");
  


    fetchAssignments();
    Authorizer();
  }, []);

  useEffect(() => {
  if (selectedBranchId) {
    fetchAssignments();
  }
}, [selectedBranchId]);


  useEffect(() => {
    const filtered = assignments.filter(assignment =>
      assignment.class.toLowerCase().includes(searchQuery.toLowerCase()) ||
      assignment.subjectName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredAssignments(filtered);
  }, [searchQuery, assignments]);

  const handleCreateAssignment = () => {
    navigate("/assignmentcreateform");
  };

  const handleClose = () => {
    setShowModal(false);
  }

  const handleDeleteAssignment = async (id) => {
    const url = process.env.REACT_APP_BASE_URL;
    const deleteApiUrl = `${url}/AssignmentCreate/Id?Id=${id}`;
    const token = sessionStorage.getItem("token");
    try {
      setLoading(true); // Start loading
      const response = await fetch(deleteApiUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      if (response.ok) {
        const updatedAssignments = assignments.filter(
          (assignment) => assignment.assignmentId !== id
        );
        setAssignments(updatedAssignments);
        setShowModal(false);
        setSnackbarMessage('Assignment deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success");
      } else {
        // alert("Failed to delete the assignment");
         setSnackbarMessage("Failed to delete the assignment");
        setOpenSnackbar(true);
        setSnackbarSeverity("error");

      }
    } catch (error) {
      console.error("Error deleting assignment:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };


  const handleViewAssignmentFile = (filePath) => {
    const url = `${process.env.REACT_APP_DOCUMENT_URL}/${filePath}`;
    window.open(url, "_blank");
  };

  const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(1); // Reset to page 1
};

const paginatedAssignments = filteredAssignments.slice(
  (page - 1) * rowsPerPage,
  (page - 1) * rowsPerPage + rowsPerPage
);


  return (
    <Container>
     <AppBar
  position="static"
  sx={{
    backgroundColor: "#0B1F3D",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
  }}
>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
    
    {/* Left: Title */}
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        letterSpacing: "0.5px",
        color: "#ffffff",
      }}
    >
     Assignments List
    </Typography>

    {/* Right: Branch Dropdown */}
   {isMaster && (
  <Box sx={{ position: "relative" }}>
    <FormControl size="small" sx={{ width: 220 }}>
      <InputLabel
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "0.75rem",
          fontWeight: 500,
          letterSpacing: "0.6px",
          textTransform: "uppercase",
          top: "-2px",
          "&.Mui-focused": { color: "#64B5F6" },
          "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
        }}
      >
        Branch
      </InputLabel>
      <Select
        value={selectedBranchId || ""}
        onChange={(e) => setSelectedBranchId(e.target.value)}
        label="Branch"
        startAdornment={
          <InputAdornment position="start">
            <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
          </InputAdornment>
        }
        sx={{
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "0.875rem",
          letterSpacing: "0.3px",
          backgroundColor: "rgba(255,255,255,0.07)",
          backdropFilter: "blur(8px)",
          borderRadius: "8px",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.15)",
            borderWidth: "1px",
            transition: "border-color 0.2s ease",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.11)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.35)",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(255,255,255,0.1)",
            boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#64B5F6",
              borderWidth: "1.5px",
            },
          },
          "& .MuiSelect-icon": {
            color: "rgba(255,255,255,0.5)",
            transition: "color 0.2s ease",
          },
          "&.Mui-focused .MuiSelect-icon": {
            color: "#64B5F6",
          },
          "& .MuiSelect-select": {
            py: 1.1,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              borderRadius: "10px",
              border: "1px solid rgba(11,31,61,0.12)",
              boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              "& .MuiList-root": { py: 0.5 },
            },
          },
        }}
      >
        {branches.map((branch) => (
          <MenuItem
            key={branch.branchId}
            value={branch.branchId}
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#0B1F3D",
              px: 2,
              py: 1.1,
              mx: 0.5,
              borderRadius: "6px",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "rgba(11,31,61,0.07)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(25,118,210,0.1)",
                color: "#1565C0",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(25,118,210,0.15)",
                },
              },
            }}  
          >
            {branch.branchName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
)}
  </Toolbar>
</AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <Grid container justifyContent="center" alignItems="center">
        </Grid>
        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', margin: "10px auto" }}>
          <TextField
            type="text"
            id="search"
            placeholder="Search Class or Subject"
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <Tooltip title={!canAdd && "You are not Authorized to Create"} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleCreateAssignment}
                color="primary"
                style={{
                  width: "180px",
                  height: "50px",
                  padding: "10px 0",
                  fontWeight: 'bold'
                }}
                disabled={!canAdd}
              >
                Create Assignment
              </Button>
            </span>
          </Tooltip>
        </div>
        <TableContainer component={Paper} style={{  marginTop: 16 }}>
          <Table
            stickyHeader
            sx={{
              minWidth: 650,
              border: '1px solid #ccc',
              '& .MuiTableCell-root': {
                borderRight: '1px solid #ccc',
                fontSize: '1rem',
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Serial No
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Class
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Subject
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Assignment Creation Date
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                  Last Submission Date
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'center' }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
           <TableBody>
  {loading ? (
    <TableRow>
      <TableCell colSpan={6} align="center">
        <CircularProgress />
      </TableCell>
    </TableRow>
  ) : paginatedAssignments.length > 0 ? (
    paginatedAssignments.map((assignment, index) => (
      <TableRow key={assignment.assignmentId} sx={{ borderTop: '1px solid #ccc' }}>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          {(page - 1) * rowsPerPage + index + 1}
        </TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          {assignment.class}
        </TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          {assignment.subjectName}
        </TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          {assignment.assignmentdate}
        </TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          {assignment.submissiondate}
        </TableCell>
        <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
          <IconButton
            onClick={() => handleViewAssignmentFile(assignment.assignmentFilePath)}
            color="primary"
          >
            <VisibilityIcon />
          </IconButton>
          <Tooltip title={!canEdit && "You are not Authorized to Edit"} arrow>
            <span>
              <IconButton
  aria-label="edit"
  onClick={() => navigate(`/updateassignment/${assignment.assignmentId}?Branch_Id=${isMaster ? selectedBranchId : sessionStorage.getItem("branchId")}`)}
  disabled={!canEdit}
>
  <EditIcon />
</IconButton>

            </span>
          </Tooltip>
          <Tooltip title={!canDelete && "You are not Authorized to Delete"} arrow>
            <span>
              <IconButton
                onClick={() => {
                  setShowModal(true);
                  setAssignmentToDelete(assignment.assignmentId);
                }}
                color="error"
                disabled={!canDelete}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={6} align="center">
        No assignments found
      </TableCell>
    </TableRow>
  )}
</TableBody>


          </Table>
        </TableContainer>
        {filteredAssignments.length > 0 && (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
    <TextField
      select
      label="Rows per page"
      value={rowsPerPage}
      onChange={handleChangeRowsPerPage}
      sx={{ width: 150 }}
      SelectProps={{
        native: true,
      }}
    >
      {rowsPerPageOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </TextField>
    <Box>
      <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
        Page {page} of {Math.ceil(filteredAssignments.length / rowsPerPage)}
      </Typography>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page - 1)}
        disabled={page === 1}
        sx={{ mr: 1 }}
      >
        Prev
      </Button>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page + 1)}
        disabled={page >= Math.ceil(filteredAssignments.length / rowsPerPage)}
      >
        Next
      </Button>
    </Box>
  </Box>
)}

      </Paper>

      <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete this Assignment ?
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => { handleDeleteAssignment(assignmentToDelete) }}
              >
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>


      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>


    </Container>
  );
}

export default AssignmentCreate;
